import { createObject } from '@/utils/objects'

export const editNetworkList = (networks) => networks.map((network) => {
  const isEditing = true
  return createObject(network, { isEditing })
})

export const editNetwork = (networkToEdit, networks) => networks.map((network) => {
  const isEditing = networkToEdit.index === network.index
  return createObject(network, { isEditing })
})

export const addNetwork = (networkToAdd, networksArray) => {
  const networks = networksArray.map((network) => createObject(network, { isEditing: false }))

  networks.push(networkToAdd)

  return networks
}

export const deleteNetwork = (networkIndexToRemove, networksArray) => {
  const networks = networksArray.map((network) => createObject(network, { isEditing: false }))

  networks.splice(networkIndexToRemove, 1)

  return networks
}

export const pushNetwork = (networks) => {
  const newNetwork = {
    associationId: null,
    index: networks.length,
    isEditing: true,
    reportPath: null,
    baseReportName: null,
    routeName: null,
    subId: null,
  }

  networks.push(newNetwork)

  return networks
}
